import './RoundButton.scss';

function RoundButton({ className, handleClick, btnText, ...props }) {
  return (
    <button type="button" className={`round_btn${className ? ` ${className}` : ''}`} onClick={handleClick} {...props}>
      {btnText}
    </button>
  );
}

export default RoundButton;

